import { createStore } from 'vuex'
import axios from '../api/index';
import router from '@/router'
import { Common } from "./Common";
import mgrCdApi from "@/api/mgr/admin_mgrCdMng";
import mgrMgrInfoApi from "@/api/mgr/admin_mgrMgrInfo";

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: true,
    sidebarUnfoldableFix: true,
    menuNav : [],
    token: null,
    pageSize: 15,
    mbrSn: 0,
    mbrInfo : {},

    mbrId: '',
    mbrNm: '',
    jbgdNm: '',
    telno: '',
    inq: false,
    reg: false,
    del: false,
    excel: false,
    authorGroupNm : '',
    cdList : [],

    ordSubmitData : {},
    ordSearchData : {},

    pushSubmitData : {},
    pushSearchData : {},

    firebaseConfig : {
      apiKey: "AIzaSyCkuHAK22lSEPAmm2Kf6oFx2YktlYt5qus",
      authDomain: "trophylab-96ccb.firebaseapp.com",
      projectId: "trophylab-96ccb",
      storageBucket: "trophylab-96ccb.appspot.com",
      messagingSenderId: "556699926665",
      appId: "1:556699926665:web:764dce89d71199e74f0658",
      measurementId: "G-3H9LLJJE6L"
    },
    vapidKey : "BO9JacucSzqV_TczSMKtNUE9kQ6H_qCYz5thHbhU0L_SIBq8_5QHDKiocPbPFslfgn5VxCWQU2Fjv0nKvvPs6oM",
    goServiceKey : 'fU4uuL7s90E2k9mcw5X87jzXfIqUE+TL/RcC/Ysv/sUK+9lczgfuKDk/PXu2YnVO/2CgA6HPUepSry4DiDoTDw==',
    // serverUrl : "http://localhost:8081",
    serverUrl : "",
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
      if(state.sidebarVisible) {
        state.sidebarUnfoldable = false;
        state.sidebarUnfoldableFix = false;
        localStorage.setItem('sidebar', '3');
      } else {
        state.sidebarUnfoldable = false;
        localStorage.setItem('sidebar', '0');
      }
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldableFix = !state.sidebarUnfoldableFix
      state.sidebarUnfoldable = state.sidebarUnfoldableFix;
      if(state.sidebarUnfoldableFix) {
        localStorage.setItem('sidebar', '2');
      }
      else {
        localStorage.setItem('sidebar', '3');
      }
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value

      if(!state.sidebarVisible) localStorage.setItem('sidebar', '0');
      else if(state.sidebarUnfoldable) localStorage.setItem('sidebar', '2');
      else localStorage.setItem('sidebar', '1');
    },
    updateSidebar(state, sidebarStatus) {
      if(sidebarStatus == '0') {
        state.sidebarVisible = false;
      }
      else if(sidebarStatus == '1') {
        state.sidebarVisible = true;
        state.sidebarUnfoldable = false;
        
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            //모바일일 경우 클릭시 고정으로 처리됨.
            state.sidebarUnfoldableFix = false;
        }

      } else if(sidebarStatus == '2') {
        state.sidebarVisible = true;
        state.sidebarUnfoldable = true;
      } else if(sidebarStatus == '3') {
        state.sidebarVisible = true;
        state.sidebarUnfoldable = false;
        state.sidebarUnfoldableFix = false;
      }
    },
    // updatePageSize(state, pageSize) {
    //   state.pageSize = pageSize;
    //   localStorage.setItem('pageSize',pageSize);
    // },
    setMenuNav(state, nav) {
      if(state.menuNav != nav) {
        state.menuNav = nav;
        if (nav != null && nav != '') {
          localStorage.setItem('nav', JSON.stringify(nav));
        }
      }
    },
    loadMenuNav(state, go) {
      let homePath = '/';

      axios.get('/api/admin/listMgrMenuMngByMenuTreeByAuthor')
        .then((response) => {
          // console.log(response);
          const data = response.data.data
          const list = data.content
          let newNav = [];
          // let upMenuNo = -1;
          for (let i = 0; i < list.length; i++) {
            const upMenuMngData = list[i]
            if(upMenuMngData.menuSn == 0) {
              let navItem = {name: upMenuMngData.menuNm,
                to: upMenuMngData.menuUrl,
                icon: JSON.parse(upMenuMngData.dtlInfo).menuIcon,
                upMenuSn: upMenuMngData.upMenuSn,
                visible: false
              }

              if(upMenuMngData.menuUrl == '') {
                navItem['component'] = 'CNavGroup';
                navItem['items'] = [];
              } else {
                navItem['component'] = 'CNavItem';
              }

              newNav.push(navItem);
              // upMenuNo++;
              if(homePath == '/' && upMenuMngData.menuUrl != '') {
                homePath = upMenuMngData.menuUrl
              }
            } else {
              const upIdx =  newNav.length - 1;
              newNav[upIdx].items.push(
                {
                  component: 'CNavItem',
                  name: upMenuMngData.menuNm,
                  to: upMenuMngData.menuUrl,
                }
              )

              if(homePath == '/' && upMenuMngData.menuUrl != '') {
                homePath = upMenuMngData.menuUrl
              }
            }
          }

          //alert(newNav)
          state.menuNav = newNav
          localStorage.setItem('nav', JSON.stringify(newNav));
          if(go != null && go == 'main') {
            //메인으로 이동
            router.push(homePath);
          }
          //console.log(this.state.homeToPath);

        })
        .catch((error) => console.log(error))
    },

    SET_USER_DATA(state, userData) {
      if(state.token != userData) {
        //console.log('SET_USER_DATA',state.token, userData);
        state.token = userData;
        if (userData != null && userData != '') {
          localStorage.setItem('token', JSON.stringify(userData));
          axios.defaults.headers.common[
            'Authorization'
            ] = `Bearer ${userData.accessToken}`;

          const parseJwt = (token) => {
            try {
              return JSON.parse(atob(token.split('.')[1]));
            } catch (e) {
              return null;
            }
          };

          const playload = parseJwt(userData.accessToken);
          if(playload != null && playload.mbrSn != null && playload.mbrSn != undefined){
            state.mbrSn = playload.mbrSn;

            mgrMgrInfoApi.getMgrInfo({params: {
                mbrSn: state.mbrSn
              }})
              .then((response) => {
                const detailData = response.data.data;
                // state.mbrNm = detailData.mbrNm;
                // state.jbgdNm = detailData.jbgdNm;
                // state.telno = detailData.telno;
                // state.mbrId = detailData.sub;

                state.mbrInfo = {
                  mbrNm : detailData.mbrNm,
                  jbgdNm : detailData.jbgdNm,
                  telno : detailData.telno,
                  mbrId : detailData.mbrId,
                  deptDc : detailData.deptDc,
                }
                if(detailData.dtlInfo != null) {
                  state.mbrInfo.dtlInfo = JSON.parse(detailData.dtlInfo)
                }
              })
              .catch((error) => console.log(error))

          }
          // console.log(playload);
          // state.mbrNm =decodeURIComponent(playload.mbrNm);
          // state.jbgdNm=decodeURIComponent(playload.jbgdNm);
          // state.telno = playload.telno;
          // state.mbrId = playload.sub;

        } else {
          localStorage.setItem('token', null);
          //localStorage.clear();
          axios.defaults.headers.common[
            'Authorization'
            ] = '';
        }
      }
    },
    // 접근한 메뉴에 대한 권한처리(조회, 등록/수정, 삭제, 엑셀다운로드)
    SET_USER_MENU_AUTHOR(state, menuUrl) {
      axios.get("/api/admin/getMgrAuthorGroupMenuMngYn", { params : { mbrSn : state.mbrSn, menuUrl : menuUrl } })
        .then((response) => {
          // console.log('getMgrAuthorGroupMenuMngYn', response);
          if(response.status == 200 && response.data.statusCode == '1') {
            let data = response.data.data;

            state.inq   = data.inqAuthorYn == "1" ? true : false;
            state.reg   = data.regAuthorYn == "1" ? true : false;
            state.del   = data.delAuthorYn == "1" ? true : false;
            state.excel = data.excelDownAuthorYn == "1" ? true : false;

            state.authorGroupNm = data.authorGroupNm;
          }
        })
        .catch((error) => console.log(error));
    },
    setCd(state, payload) {

      state.cdList = []
      // console.log("add:"+payload.upCd);
      for (let i = 0; i < payload.optionList.length; i++) {
        state.cdList.push(payload.optionList[i]);
      }
      // state.cdList.pushAll(payload.optionList);
    },
  },
  actions: {
    setCd(context) {
      setTimeout(() => {
        // console.log(context.state.cdList.filter(cd => cd.upCd === upCd).length);
        if(context.state.cdList.length === 0) {
          return mgrCdApi.listMgrCdMng({
            params: {
              page: 1,
              pageSize: 99999,
              useSttus: 1,
            }
          })
            .then((response) => {
              if (response.status == 200) {
                // const optionList = response.data.data.content;
                // console.log(response.data.data.content.length);
                context.commit("setCd", {"optionList":response.data.data.content});
              }
            })
            .catch((error) => console.log(error))
        }
      },1000)
    },
    // cdList 강제 재로드 — 공통코드(예: T024 필터 키워드) 변경 시 즉시 반영
    reloadCd(context) {
      return mgrCdApi.listMgrCdMng({
        params: {
          page: 1,
          pageSize: 99999,
          useSttus: 1,
        }
      })
        .then((response) => {
          if (response.status == 200) {
            context.commit("setCd", { "optionList": response.data.data.content });
          }
        })
        .catch((error) => console.log(error))
    },
    login({ commit }, credentials) {
      return axios
        .post("/api/admin/auth/login", null, credentials)
        .then(res => {
          if(res.status == 200 && res.data.statusCode == '1') {
            //console.log("user data is", res.data);
            commit("SET_USER_DATA", res.data.data);

          }
          return res;
        })
        ;
    },
    logout({ commit }, credentials) {
      return axios
        .post("/api/auth/logout", null, credentials)
        .then(res => {
          if(res.status == 200) {
            //console.log("user data is", res.data);
            commit("SET_USER_DATA", null);
            this.$router.push({name: "Login"});
          }
        });
    },
  },
  modules: {
    Common
  },
  getters: {
    loggedIn(state) {
      return !!state.token;
    },
    getCd: (state) => (upCd) => {
      return state.cdList.filter(cd => cd.upCd === upCd)
    },
    getCdDetail: (state) => (cd) => {
      return state.cdList.filter(data => data.cd === cd)
    },
  }
})
